import { render, staticRenderFns } from "./SearchPage.vue?vue&type=template&id=b0ea2c40&scoped=true"
import script from "./SearchPage.vue?vue&type=script&lang=js"
export * from "./SearchPage.vue?vue&type=script&lang=js"
import style0 from "./SearchPage.vue?vue&type=style&index=0&id=b0ea2c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ea2c40",
  null
  
)

export default component.exports